import React, { useState, useEffect } from 'react'
import { supabase } from './supabase'
import LoginPage from './components/auth/LoginPage'
import RegisterPage from './components/auth/RegisterPage'
import LandingPage from './components/landing/LandingPage'
import MentionsLegales from './components/legal/MentionsLegales'
import CGV from './components/legal/CGV'
import RGPD from './components/legal/RGPD'
import CGU from './components/legal/CGU'
import ResetPassword from './components/ResetPassword'
import AppLayout from './components/layout/AppLayout'
import ArchitecteDashboard from './components/dashboards/ArchitecteDashboard'
import EntrepriseDashboard from './components/dashboards/EntrepriseDashboard'
import ClientDashboard from './components/dashboards/ClientDashboard'
import ErrorBoundary from './components/ErrorBoundary'
import NotFound from './components/NotFound'
import './App.css'

// Demo profile et donnees fictives
const DEMO_PROFILE = {
  id: 'demo-user',
  role: 'architecte',
  nom: 'Martin',
  prenom: 'Sophie',
  email: 'sophie.martin@archi-demo.fr',
  abonnement_actif: true,
  date_expiration: new Date(Date.now() + 25 * 24 * 60 * 60 * 1000).toISOString(),
}

const DEMO_DATA = {
  chantiers: [
    {
      id: 'demo-1',
      nom: 'Villa Les Pins - Renovation complete',
      adresse: '14 chemin des Pins, 06250 Mougins',
      statut: 'en_cours',
      progression: 62,
      code: 'XK4T9P',
      architecte_id: 'demo-user',
      created_at: '2025-11-03T09:00:00Z',
      budget: 185000,
    },
    {
      id: 'demo-2',
      nom: 'Appartement Haussmann - Refonte interieure',
      adresse: '8 rue du Faubourg Saint-Honore, 75008 Paris',
      statut: 'en_cours',
      progression: 34,
      code: 'MR7PLQ',
      architecte_id: 'demo-user',
      created_at: '2026-01-15T14:00:00Z',
      budget: 97000,
    },
    {
      id: 'demo-3',
      nom: 'Maison Dupont - Extension garage',
      adresse: '3 allee des Chenes, 31400 Toulouse',
      statut: 'planifie',
      progression: 8,
      code: 'BZ2WNC',
      architecte_id: 'demo-user',
      created_at: '2026-03-20T10:00:00Z',
      budget: 42000,
    },
  ],
  taches: [
    { id: 'dt-1', chantier_id: 'demo-1', titre: 'Demolition cloisons R+1', statut: 'termine', priorite: 'haute', assigned_to: null, created_at: '2025-11-10T08:00:00Z' },
    { id: 'dt-2', chantier_id: 'demo-1', titre: 'Installation plomberie salle de bain', statut: 'en_cours', priorite: 'haute', assigned_to: null, created_at: '2025-12-01T08:00:00Z' },
    { id: 'dt-3', chantier_id: 'demo-1', titre: 'Pose carrelage cuisine', statut: 'en_cours', priorite: 'normale', assigned_to: null, created_at: '2026-01-05T08:00:00Z' },
    { id: 'dt-4', chantier_id: 'demo-1', titre: 'Peinture facade exterieure', statut: 'en_attente', priorite: 'normale', assigned_to: null, created_at: '2026-02-10T08:00:00Z' },
    { id: 'dt-5', chantier_id: 'demo-2', titre: 'Depose parquet ancien', statut: 'termine', priorite: 'haute', assigned_to: null, created_at: '2026-01-20T08:00:00Z' },
    { id: 'dt-6', chantier_id: 'demo-2', titre: 'Pose parquet chene massif', statut: 'en_cours', priorite: 'haute', assigned_to: null, created_at: '2026-02-01T08:00:00Z' },
    { id: 'dt-7', chantier_id: 'demo-2', titre: 'Installation electrique tableau', statut: 'en_attente', priorite: 'haute', assigned_to: null, created_at: '2026-02-15T08:00:00Z' },
    { id: 'dt-8', chantier_id: 'demo-3', titre: 'Obtention permis de construire', statut: 'en_cours', priorite: 'haute', assigned_to: null, created_at: '2026-03-22T08:00:00Z' },
  ],
}

function LoadingScreen() {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', height: '100vh',
      background: 'linear-gradient(135deg, #f0fdf8 0%, #e8f7f2 100%)', gap: 16,
    }}>
      <div style={{
        width: 56, height: 56, background: '#1D9E75', borderRadius: 14,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        color: 'white', fontSize: 26, fontWeight: 700,
        boxShadow: '0 8px 24px rgba(29,158,117,0.3)',
      }}>C</div>
      <div style={{ fontSize: 14, color: '#718096' }}>Chargement...</div>
    </div>
  )
}

function BanniereExpiration({ dateExpiration, onRenouveler }) {
  if (!dateExpiration) return null
  const jours = Math.ceil((new Date(dateExpiration) - new Date()) / (1000 * 60 * 60 * 24))
  if (jours > 7) return null
  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 999,
      background: jours <= 0 ? '#e53e3e' : '#f6ad55',
      color: 'white', padding: '10px 20px',
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 16,
      fontSize: 14, fontWeight: 500,
    }}>
      <span>
        {jours <= 0
          ? 'Abonnement expire - creation de chantiers bloquee.'
          : 'Abonnement expire dans ' + jours + ' jour' + (jours > 1 ? 's' : '') + '.'}
      </span>
      <button onClick={onRenouveler} style={{
        background: 'rgba(255,255,255,0.25)', border: '1px solid rgba(255,255,255,0.5)',
        color: 'white', padding: '4px 14px', borderRadius: 20, fontSize: 13, cursor: 'pointer', fontWeight: 600,
      }}>
        Renouveler
      </button>
    </div>
  )
}

function BanniereBeta({ onFeedback }) {
  const [visible, setVisible] = React.useState(() => localStorage.getItem('beta_banner_dismissed') !== '1')
  if (!visible) return null
  const dismiss = () => { localStorage.setItem('beta_banner_dismissed', '1'); setVisible(false) }
  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
      background: '#1a202c', color: 'white',
      padding: '8px 20px',
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 16,
      fontSize: 13, fontWeight: 500,
    }}>
      <span style={{ opacity: 0.8 }}>🚧</span>
      <span>
        <strong style={{ color: '#68d391' }}>Version Beta</strong>
        {' '}— Application en cours de test. Des bugs peuvent survenir. Votre retour nous aide a ameliorer Suiveo.
      </span>
      <button onClick={onFeedback} style={{
        background: '#1D9E75', border: 'none', color: 'white',
        padding: '4px 14px', borderRadius: 20, fontSize: 12, cursor: 'pointer', fontWeight: 600, flexShrink: 0,
      }}>
        Donner mon avis
      </button>
      <button onClick={dismiss} title="Fermer" style={{
        background: 'none', border: 'none', color: 'rgba(255,255,255,0.5)',
        cursor: 'pointer', fontSize: 16, padding: '0 4px', flexShrink: 0, lineHeight: 1,
      }}>×</button>
    </div>
  )
}

function ModalFeedback({ onClose, user }) {
  const [msg, setMsg] = React.useState('')
  const [sent, setSent] = React.useState(false)
  const handleSend = async () => {
    if (!msg.trim()) return
    await supabase.from('feedbacks').insert([{ contenu: msg.trim(), created_at: new Date().toISOString(), user_id: user?.id }]).catch(() => {})
    setSent(true)
    setTimeout(onClose, 2000)
  }
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000, padding: 20 }}>
      <div style={{ background: 'white', borderRadius: 14, padding: '28px 32px', maxWidth: 440, width: '100%' }}>
        {sent ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>🙏</div>
            <div style={{ fontSize: 16, fontWeight: 700, color: '#1D9E75' }}>Merci pour votre retour !</div>
            <div style={{ fontSize: 13, color: '#718096', marginTop: 6 }}>Votre avis nous aide a ameliorer Suiveo.</div>
          </div>
        ) : (
          <>
            <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 6 }}>Donner votre avis</div>
            <div style={{ fontSize: 13, color: '#718096', marginBottom: 16 }}>
              Un bug ? Une fonctionnalite manquante ? Une idee d'amelioration ? Tout est bon a prendre.
            </div>
            <textarea
              value={msg} onChange={e => setMsg(e.target.value)}
              placeholder="Decrivez ce qui ne va pas ou ce que vous aimeriez voir..."
              rows={5} style={{
                width: '100%', padding: '10px 12px', border: '1.5px solid #e2e8f0',
                borderRadius: 8, fontSize: 14, resize: 'vertical', outline: 'none',
                fontFamily: 'inherit', boxSizing: 'border-box',
              }}
              onFocus={e => e.target.style.borderColor = '#1D9E75'}
              onBlur={e => e.target.style.borderColor = '#e2e8f0'}
            />
            <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
              <button onClick={onClose} style={{ flex: 1, padding: '10px 0', background: '#f5f6fa', border: '1.5px solid #e2e8f0', borderRadius: 8, cursor: 'pointer', fontWeight: 500 }}>Annuler</button>
              <button onClick={handleSend} disabled={!msg.trim()} style={{ flex: 1, padding: '10px 0', background: msg.trim() ? '#1D9E75' : '#e2e8f0', color: msg.trim() ? 'white' : '#a0aec0', border: 'none', borderRadius: 8, cursor: msg.trim() ? 'pointer' : 'default', fontWeight: 600 }}>Envoyer</button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

function BanniereDemo({ onQuitter }) {
  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 999,
      background: 'linear-gradient(90deg, #6c63ff, #1D9E75)',
      color: 'white', padding: '10px 20px',
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 16,
      fontSize: 14, fontWeight: 500,
    }}>
      <span>Mode demonstration - donnees fictives</span>
      <button onClick={onQuitter} style={{
        background: 'rgba(255,255,255,0.25)', border: '1px solid rgba(255,255,255,0.5)',
        color: 'white', padding: '4px 14px', borderRadius: 20, fontSize: 13, cursor: 'pointer', fontWeight: 600,
      }}>
        Quitter la demo
      </button>
    </div>
  )
}

function ModalRenouvellement({ userId, userEmail, onClose }) {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const renouveler = async () => {
    setLoading(true)
    setError('')
    try {
      const { data: { session: authSession } } = await supabase.auth.getSession()
      const response = await fetch('/api/create-checkout-session', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authSession?.access_token}`,
        },
        body: JSON.stringify({ userId, email: userEmail }),
      })
      const data = await response.json()
      if (data.url) {
        window.location.href = data.url
      } else {
        setError('Erreur lors de la redirection vers le paiement.')
        setLoading(false)
      }
    } catch (err) {
      setError('Erreur : ' + err.message)
      setLoading(false)
    }
  }
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 300, padding: 20 }}>
      <div style={{ background: 'white', borderRadius: 14, padding: '32px 36px', maxWidth: 400, width: '100%', textAlign: 'center' }}>
        <div style={{ fontSize: 40, marginBottom: 12 }}>🔄</div>
        <h3 style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>Renouveler l abonnement</h3>
        <p style={{ fontSize: 14, color: '#718096', marginBottom: 24 }}>Prolongez votre acces de 30 jours supplementaires.</p>
        <div style={{ background: '#e8f7f2', borderRadius: 10, padding: 16, marginBottom: 24, fontSize: 28, fontWeight: 800, color: '#1D9E75' }}>20€ / mois</div>
        {error && <div style={{ fontSize: 13, color: '#e53e3e', marginBottom: 12 }}>{error}</div>}
        <div style={{ display: 'flex', flexDirection: 'row', gap: 10 }}>
          <button onClick={onClose} style={{ flex: 1, padding: '10px 16px', background: '#f5f6fa', border: '1.5px solid #e2e8f0', borderRadius: 8, cursor: 'pointer', fontWeight: 500, writingMode: 'horizontal-tb', whiteSpace: 'nowrap' }}>Annuler</button>
          <button onClick={renouveler} disabled={loading} style={{ flex: 1, padding: '10px 16px', background: '#1D9E75', color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600, opacity: loading ? 0.7 : 1, writingMode: 'horizontal-tb', whiteSpace: 'nowrap' }}>
            {loading ? 'En cours...' : 'Payer 20€'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default function App() {
  const [user, setUser] = useState(null)
  const [profile, setProfile] = useState(null)
  const [authLoading, setAuthLoading] = useState(true)
  const [showRegister, setShowRegister] = useState(false)
  const [activePage, setActivePage] = useState('dashboard')
  const [showRenouvellement, setShowRenouvellement] = useState(false)
  const [showFeedback, setShowFeedback] = useState(false)
  const [clientMode, setClientMode] = useState(null)
  const [demoMode, setDemoMode] = useState(false)
  const [showLanding, setShowLanding] = useState(true)
  const [legalPage, setLegalPage] = useState(null) // 'mentions' | 'cgv' | null
  const [emailConfirmed, setEmailConfirmed] = useState(false)
  const [paymentSuccess, setPaymentSuccess] = useState(false)
  const [showResetPassword, setShowResetPassword] = useState(false)

  useEffect(() => {
    const code = localStorage.getItem('cp_client_code')
    if (code) {
      supabase.from('chantiers').select('*').eq('code', code).single()
        .then(({ data }) => {
          if (data) setClientMode({ chantier: data })
          else localStorage.removeItem('cp_client_code')
        })
    }
  }, [])

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session && session.user) {
        setUser(session.user)
        loadProfile(session.user)
      } else {
        setAuthLoading(false)
      }
    })
    const { data: authData } = supabase.auth.onAuthStateChange((_event, session) => {
      if (_event === 'SIGNED_IN' && session && session.user) {
        setUser(session.user)
        setShowLanding(false)
        loadProfile(session.user)
      } else if (_event === 'PASSWORD_RECOVERY') {
        setShowLanding(false)
      } else if (session && session.user) {
        setUser(session.user)
        loadProfile(session.user)
      } else {
        setUser(null)
        setProfile(null)
        setAuthLoading(false)
      }
    })

    // Detecter confirmation email dans l'URL
    const hash = window.location.hash
    if (hash && hash.includes('type=signup')) {
      setEmailConfirmed(true)
      setShowLanding(false)
      window.history.replaceState(null, '', window.location.pathname)
    }

    // Detecter lien de réinitialisation mot de passe
    if (hash && hash.includes('type=recovery')) {
      setShowResetPassword(true)
      setShowLanding(false)
    }

    // Detecter retour paiement Stripe
    const params = new URLSearchParams(window.location.search)
    if (params.get('payment') === 'success') {
      setPaymentSuccess(true)
      setShowLanding(false)
      window.history.replaceState(null, '', window.location.pathname)
    }
    return () => authData.subscription.unsubscribe()
  }, [])

  const loadProfile = async (u) => {
    const { data } = await supabase.from('profiles').select('*').eq('id', u.id).single()
    setProfile(data || null)
    setAuthLoading(false)
  }

  const handleLogout = async () => {
    await supabase.auth.signOut()
    setUser(null)
    setProfile(null)
    setActivePage('dashboard')
  }

  const handleClientAccess = (chantier) => {
    setClientMode({ chantier })
  }

  const handleClientQuitter = () => {
    localStorage.removeItem('cp_client_code')
    setClientMode(null)
  }

  const handleDemoMode = () => {
    setDemoMode(true)
    setActivePage('dashboard')
  }

  const handleQuitterDemo = () => {
    setDemoMode(false)
    setActivePage('dashboard')
  }

  const tutorielRelancerRef = React.useRef(null)
  const handleRelancerTutoriel = () => {
    if (tutorielRelancerRef.current) tutorielRelancerRef.current()
  }

  // eslint-disable-next-line no-unused-vars
  const handleRenewed = () => { if (user) loadProfile(user) }

  if (clientMode) {
    return <ClientDashboard chantier={clientMode.chantier} onQuitter={handleClientQuitter} />
  }

  if (authLoading) return <LoadingScreen />

  if (demoMode) {
    return (
      <>
        <BanniereDemo onQuitter={handleQuitterDemo} />
        <div style={{ paddingTop: 44 }}>
          <AppLayout role="architecte" activePage={activePage} onNavigate={setActivePage} user={null} onLogout={handleQuitterDemo} profile={DEMO_PROFILE} onRelancerTutoriel={handleRelancerTutoriel}>
            <ArchitecteDashboard
              activePage={activePage}
              onNavigate={setActivePage}
              user={{ id: 'demo-user', email: 'sophie.martin@archi-demo.fr' }}
              profile={DEMO_PROFILE}
              abonnementExpire={false}
              onDemandeRenouvellement={() => {}}
              isDemoMode={true}
              demoData={DEMO_DATA}
              onRelancerTutoriel={fn => { tutorielRelancerRef.current = fn }}
            />
          </AppLayout>
        </div>
      </>
    )
  }

  // Pages legales (accessibles depuis partout)
  if (legalPage === 'mentions') return <MentionsLegales onRetour={() => setLegalPage(null)} />
  if (legalPage === 'cgv') return <CGV onRetour={() => setLegalPage(null)} />
  if (legalPage === 'rgpd') return <RGPD onRetour={() => setLegalPage(null)} />
  if (legalPage === 'cgu') return <CGU onRetour={() => setLegalPage(null)} />

  if (showResetPassword) {
    return (
      <ResetPassword
        onRetourLogin={() => {
          setShowResetPassword(false)
          setShowLanding(false)
          window.history.replaceState(null, '', window.location.pathname)
        }}
      />
    )
  }

  if (!user) {
    if (showRegister) {
      return <RegisterPage onRegistered={() => setShowRegister(false)} onBackToLogin={() => { setShowRegister(false); setShowLanding(true) }} />
    }
    if (showLanding) {
      return (
        <LandingPage
          onShowLogin={() => setShowLanding(false)}
          onShowRegister={() => { setShowLanding(false); setShowRegister(true) }}
          onShowMentions={() => setLegalPage('mentions')}
          onShowCGV={() => setLegalPage('cgv')}
          onShowRGPD={() => setLegalPage('rgpd')}
          onShowCGU={() => setLegalPage('cgu')}
        />
      )
    }
    return (
      <LoginPage
        onLogin={(u) => { setUser(u); loadProfile(u) }}
        onShowRegister={() => setShowRegister(true)}
        onShowLanding={() => setShowLanding(true)}
        onClientAccess={handleClientAccess}
        onDemoMode={handleDemoMode}
        emailConfirmed={emailConfirmed}
        paymentSuccess={paymentSuccess}
      />
    )
  }

  const role = (profile && profile.role) ? profile.role : 'entreprise'
  // MODE BETA GRATUIT — désactiver pour repasser en mode payant
  const abonnementExpire = false
  const showBanniere = false
  const dateExp = null
  // eslint-disable-next-line no-unused-vars
  const joursRestants = null

  const renderDashboard = () => {
    if (role === 'architecte') {
      return <ArchitecteDashboard activePage={activePage} onNavigate={setActivePage} user={user} profile={profile} abonnementExpire={abonnementExpire} onDemandeRenouvellement={() => setShowRenouvellement(true)} isDemoMode={false} demoData={null} onRelancerTutoriel={fn => { tutorielRelancerRef.current = fn }} />
    }
    if (role === 'entreprise') {
      return <EntrepriseDashboard activePage={activePage} onNavigate={setActivePage} user={user} onRelancerTutoriel={fn => { tutorielRelancerRef.current = fn }} />
    }
    if (role === 'client') {
      return <EntrepriseDashboard activePage={activePage} onNavigate={setActivePage} user={user} />
    }
    // Fallback 404 pour tout rôle inconnu
    return <NotFound onRetour={() => setActivePage('dashboard')} />
  }

  const topPadding = showBanniere ? 96 : 52

  return (
    <ErrorBoundary>
      <BanniereBeta onFeedback={() => setShowFeedback(true)} />
      {showBanniere && (
        <BanniereExpiration dateExpiration={dateExp} onRenouveler={() => setShowRenouvellement(true)} />
      )}
      <div style={{ paddingTop: topPadding }}>
        <AppLayout role={role} activePage={activePage} onNavigate={setActivePage} user={user} onLogout={handleLogout} profile={profile} onRelancerTutoriel={handleRelancerTutoriel}>
          {renderDashboard()}
        </AppLayout>
      </div>
      {showRenouvellement && (
        <ModalRenouvellement userId={user.id} userEmail={user.email} onClose={() => setShowRenouvellement(false)} />
      )}
      {showFeedback && <ModalFeedback onClose={() => setShowFeedback(false)} user={user} />}
    </ErrorBoundary>
  )
}
